module.exports = __webpack_public_path__ + "img/01dffd9.png";